import Cookies from 'js-cookie';
import { Dialog } from 'vant';
import JsBridge from '@/utils/webViewJsBridge';

const TokenKey = 'Admin-Token';
const uaStr = window.navigator.userAgent;

function getFromKey() {
  return Cookies.get(TokenKey);
}
getFromKey();

const gooutAppData = {
  'pageKey': 'hy002',
  'isClearStack': true
};
// 处理UA字符串判断平台 miniProgram 明康汇小程序  MKH-APP  明康汇APP
export function getplantForm() {
  if (uaStr.indexOf('miniProgram') !== -1) {
    return 'miniProgram';
  } else {
    if (uaStr.indexOf('MKH-APP') !== -1) {
      return 'MKH-APP';
    } else {
      return false;
    }
  }
}

export function errorGoOutWeb() {
  let plant = getplantForm();
  Dialog.alert({
    title: '系统提示',
    message: '授权状态已过期或授权失败',
    confirmButtonText: '重新授权',
    confirmButtonColor: '#0F47C1',
    className: 'logout-dialog'
  })
    .then(() => {
      if (plant === 'miniProgram') {
        window.wx.miniProgram.navigateBack({
          delta: 1
        });
      }
      if (plant === 'MKH-APP') {
        JsBridge.callhandler('navigateTo', gooutAppData, function(data) {
          console.log(data);
        });
      }
    })
    .catch(() => {
      // on cancel
    });
}

export function goOutWeb() {
  let plant = getplantForm();
  if (plant === 'miniProgram') {
    window.wx.miniProgram.navigateBack({
      delta: 1
    });
  }
  if (plant === 'MKH-APP') {
    JsBridge.callhandler('navigateTo', gooutAppData, function(data) {
      console.log(data);
    });
  }
}

// if (getplantForm() === 'MKH-APP') {
//   console.log('jsbridge初始化开始');
//   // alert("ready");
//   setupWebViewJavascriptBridge(async(b) => {
//     webviewJsBridge = b;
//     console.log('jsbridge初始化成功', b);
//     await this.getSystemInfo().then((systemInfo) => {
//       console.log(systemInfo);
//     });
//     callback();
//   });
// }



// WEBPACK FOOTER //
// ./src/utils/thirdAuth.js